import type { DerogationActionEnumKey, DerogationStatusEnumKey } from 'korint-sdk';
import { useTranslation } from 'react-i18next';
import { usePolicyStatuses } from '../../../hooks/usePolicyStatuses';
import { StatusPill } from '../../ui/status-pill';

const defaultDerogationStatuses: Record<DerogationStatusEnumKey, string> = {
  CREATED: 'bg-indigo-100 text-indigo-700',
  DENIED: 'bg-gray-100 text-gray-700',
  APPROVED: 'bg-green-100 text-green-700',
};

const defaultDerogationActions: Record<DerogationActionEnumKey, string> = {
  QUOTE: 'bg-indigo-100 text-indigo-700',
  CONFIRM: 'bg-indigo-100 text-indigo-700',
  SIGN: 'bg-green-100 text-green-700',
  STOP: 'bg-orange-100 text-orange-700',
};

const defaultDerogationColorsByNamespace: Record<string, Record<string, string>> = {
  derogationStatus: defaultDerogationStatuses,
  derogationAction: defaultDerogationActions,
};

interface StatusCellProps {
  value: string;
  statuses?: Record<string, string>;
  policyProductId?: string;
  translationNamespace?: string;
}

export function StatusCell({
  value,
  statuses,
  policyProductId,
  translationNamespace = 'policyStatus',
}: StatusCellProps) {
  const { t } = useTranslation();
  const policyStatuses = usePolicyStatuses();
  const colors =
    statuses ??
    (translationNamespace === 'policyStatus'
      ? policyStatuses
      : defaultDerogationColorsByNamespace[translationNamespace]);

  return (
    <StatusPill
      color={colors?.[value]}
      label={t([
        `${policyProductId}.${translationNamespace}.${value}`,
        `${translationNamespace}.${value}`,
      ])}
    />
  );
}
